import { render, staticRenderFns } from "./classify.vue?vue&type=template&id=acaf92da&scoped=true"
import script from "./classify.vue?vue&type=script&lang=js"
export * from "./classify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acaf92da",
  null
  
)

export default component.exports